import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Amplify, { Auth } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";
import windowSize from "react-window-size";
import Modal from "react-modal";
// import { ToastContainer, toast } from 'react-toastify';
import ProfilePic from "../../images/blue-logo.png";
import * as SecretKeys from "../../ENV.json";
import {
  getAffiliateDetailByAffiliateKey,
  getAllBusinessSubUsers,
  getBusinessUser,
  getNotificationLogUnReadCountForUser,
  getAllPlans,
  planPriceChange,
  logoutUser,
  clearDataEmail,
  requestCreateFusebillCustomer,
  getAllFilteredSettlement,
  getPromotedSettlementByUserId,
  getAllFilteredDSettlement,
  getAllDashboard,
  tutorialPopupStateAction2,
  tutorialPopupStateAction3,
} from "../../Actions/actions";
// import 'react-toastify/dist/ReactToastify.css';
import PlanPage from "../signup/planPage";
import loader from "../../images/Spin-1s-107px.gif";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -10%)",
  },
};

Amplify.configure(SecretKeys.awsUserpool);

// Amplify.configure(SecretKeys.awsUserpool);
class SideMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isToggle: true,
      userData: "",
      modalIsOpen: false,
      modal2IsOpen: false,
      planId: 21,
      getPlanNameData: "",
      userResult: {},
      affiliateKeyData: "",
      plansDataAffiliate1: [],
      AllPlansForMemberAfi: [],
      setFilteredSettlementData: [],
      planChangeTriggered: false,
      createFusebillCustomerTriggered: false,
      isLoader: false,
      isPopoOPen: false,
      allSettlementDataUpdateList: {},
      makeitAutomatic: false,
      autoLogoutTriggered: false,
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal2 = this.openModal2.bind(this);
    this.afterOpenModal2 = this.afterOpenModal2.bind(this);
    this.closeModal2 = this.closeModal2.bind(this);
    this.closeModal1 = this.closeModal1.bind(this);
    this.onPlanSelect = this.onPlanSelect.bind(this);
    this.onPlanSelectSubmit = this.onPlanSelectSubmit.bind(this);
    // this.onPlanSelectBar = this.onPlanSelectBar.bind(this);
    this.onPlanSelectBar2 = this.onPlanSelectBar2.bind(this);
    this.logout = this.logout.bind(this);
    this.onMenuSelect = this.onMenuSelect.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true, isPopoOPen: false });
  }

  openModal2() {
    this.setState({ modal2IsOpen: true });
  }

  afterOpenModal() {}

  afterOpenModal2() {}

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  closeModalPricePoup = () => {
    this.setState({ isPopoOPen: false });
  };

  closeModal2() {
    this.setState({ modal2IsOpen: false });
  }

  closeModal1(e) {
    e.preventDefault();
    this.setState({ modalIsOpen: false });
  }

  handleClickOutside = () => {
    if(localStorage.getItem("email")){
      this.props.tutorialPopupStateAction2({ tutorialPopupState2: false });
      this.props.tutorialPopupStateAction3({ tutorialPopupState3: true }); 
    }
  };

  onPlanSelectBar = async (id, selectedPlanAmount, planData) => {
    let data;
    if (
      planData.planName !== "Basic" &&
      planData.planName !== "Basic Outsourced" &&
      planData.planName !== "Basic Automatic" &&
      planData.planPriceDto[0].connectFusebill !== 0
    ) {
      data = {
        userId: localStorage.getItem("userId"),
        planPriceId: id,
        paymentStatus: "pending",
        selectedPlanName: planData.planName,
        selectedPlanAmount,
      };
    } else {
      data = {
        userId: localStorage.getItem("userId"),
        planPriceId: id,
        paymentStatus: "paid",
        selectedPlanName: planData.planName,
        selectedPlanAmount,
      };
    }

    await this.props.planPriceChange(data);
    await this.onPlanSelectSubmit();

    this.setState({ planChangeTriggered: true });
  };

  onPlanSelectBar2(id) {
    // console.log("PlanId", id);
  }

  onPlanSelect() {
    // const id = e.value;
    // this.setState({
    //   planId: id,
    // });
  }

  onPlanSelectSubmit() {
    this.closeModal();
    // toast.info('Plan updated sucessfully', {
    //   position: toast.POSITION.TOP_CENTER,
    // });
  }
  /* notify = () => toast("Wow so easy !"); */

  componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any): void {
    // Logout the user if it does not exists any more.
    if (
      this.props.data &&
      this.props.data.BusinessUserProfileData &&
      this.props.data.BusinessUserProfileData.code &&
      this.props.data.BusinessUserProfileData.code === 400 &&
      !this.state.autoLogoutTriggered
    ) {
      this.logout().then(() => {
        this.setState({ autoLogoutTriggered: true });
        console.log("Session has been ended. User does not exists anymore");
      });
    }

    // if(nextState.loaded){
    if (window.innerWidth < 993) {
      this.setState({
        isToggle: false,
      });
    } else {
      this.setState({
        isToggle: true,
      });
    }

    if (this.state.planChangeTriggered === true) {
      this.setState({ isLoader: true });
      // FuseBill Create Customer.
      if (
        nextProps.data.planUpdate &&
        nextProps.data.planUpdate.planName &&
        nextProps.data.planUpdate.planName !== "Basic" &&
        nextProps.data.planUpdate.planName !== "Basic Automatic" &&
        nextProps.data.planUpdate.planName !== "Basic Automatic" &&
        nextProps.data.userInfo.roleName === "Business-User"
      ) {
        localStorage.setItem(
          "fusebillPlanFrequencyId",
          nextProps.data.planUpdate.fusebillPlanFrequencyId
        );
        // const customerData = {
        //   customerInfo: {
        //     userId: nextProps.data.userInfo.userObject.userDto.userId,
        //     firstName: nextProps.data.userInfo.userObject.userDto.firstName,
        //     lastName: nextProps.data.userInfo.userObject.userDto.lastName,
        //     companyName: nextProps.data.userInfo.userObject.userDto.employer,
        //     primaryEmail: nextProps.data.userInfo.userObject.userDto.email
        //   },
        //   billing: {
        //     companyName: nextProps.data.userInfo.userObject.userDto.employer,
        //     line1: nextProps.data.userInfo.userObject.userDto.streeAddress,
        //     city: nextProps.data.userInfo.userObject.userDto.city,
        //     postalZip: nextProps.data.userInfo.userObject.userDto.zipCode,
        //     country: "USA",
        //     state: nextProps.data.userInfo.userObject.userDto.stateName
        //   }
        // };
        // nextProps.requestCreateFusebillCustomer(customerData);
        this.setState({ createFusebillCustomerTriggered: true });
      } else {
        this.setState({ isLoader: false });
      }
      this.setState({ planChangeTriggered: false });
    }

    if (this.state.createFusebillCustomerTriggered === true) {
      this.setState({ isLoader: false });
      if (
        nextProps.data.fusebillData &&
        nextProps.data.fusebillData.fusebillCustomerId
      ) {
        // this.context.router.history.push("/add-payment-method");
        // localStorage.setItem('changePlan', true)
      }
      this.setState({ createFusebillCustomerTriggered: false });
    }
  }

  componentWillMount() {
    const { userInfo, planUpdate } = this.props.data;
    // const userid = localStorage.getItem('userId');
    Modal.setAppElement("body");
    // const data = {
    //   userId: userid,
    // };
    if (
      typeof userInfo.user !== "undefined" &&
      window.location.pathname !== "/change-password"
    ) {
      this.props.getAllBusinessSubUsers();
    }
    this.props.getAllPlans({
      pageNumber: 0,
      pageSize: 20,
      searchKeyword: "",
      planUserType: "Business",
      userId: 0,
      affiliateKey: "",
    });
    // setTimeout(() => {
    //   // this.props.getAffiliateUserType(data);
    // }, 1000);
    if (planUpdate.planPriceId !== undefined) {
      this.setState({
        planId: planUpdate.planPriceId,
      });
    }
  }

  componentDidUpdate() {
    const {
      userData,
      getPlanNameData,
      planUpdateData,
      userResult,
      plansDataAffiliate1,
      allSettlementDataUpdateList,
      setFilteredSettlementData,
    } = this.state;
    const {
      affiliateUserTypeArray,
      planUpdate,
      userInfo,
      plansDataAffiliate,
      getDashboardData,
      setFilteredSettlement,
    } = this.props.data;

    const {
      getAllFilteredDSettlement,
      getAllFilteredSettlement,
      getPromotedSettlementByUserId,
    } = this.props;

    const plainDto = {};
    const user = JSON.parse(localStorage.getItem("userObject"));
    const userPlain = localStorage.getItem("plainNameDto");
    if (user !== null) {
      if (user.planDto !== "") {
        if (typeof user.planDto !== "undefined") {
          if (typeof user.planDto.planId !== "undefined") {
            if (getPlanNameData !== userPlain) {
              this.setState({
                getPlanNameData: userPlain,
              });
            }
          }
        }
      }
    }

    if (window.location.pathname === "/dashboard") {
      if (getDashboardData && getDashboardData.result) {
        if (
          getDashboardData.result.allSettlementData !==
          allSettlementDataUpdateList
        ) {
          this.setState({
            allSettlementDataUpdateList:
              getDashboardData.result.allSettlementData,
            isPopoOPen:
              window.location.pathname === "/dashboard"
                ? getDashboardData.result.remainingSettlement === 0
                : false,
            makeitAutomatic:
              window.location.pathname === "/dashboard"
                ? getDashboardData.result.remainingSettlement === 0
                : false,

            // isPopoOPen: getDashboardData.result.remainingSettlement === 0
          });
          if (
            window.location.pathname === "/dashboard" &&
            getDashboardData.result.remainingSettlement === 0
          ) {
            localStorage.setItem("changePlan", true);
          }
        }
      }
    }

    // if (setFilteredSettlement && setFilteredSettlement.remainingSettlement) {
    if (window.location.pathname === "/settlement") {
      if (setFilteredSettlementData !== setFilteredSettlement) {
        this.setState({
          setFilteredSettlementData: setFilteredSettlement,
          makeitAutomatic:
            window.location.pathname === "/settlement"
              ? setFilteredSettlement.remainingSettlement === 0
              : false,
        });
        if (
          window.location.pathname === "/settlement" &&
          setFilteredSettlement.remainingSettlement === 0
        ) {
          localStorage.setItem("changePlan", true);
        }
      }
    }
    // }

    if (plansDataAffiliate !== undefined) {
      if (plansDataAffiliate.result !== undefined) {
        if (plansDataAffiliate.result.affiliateActive === 1) {
          if (plansDataAffiliate1 !== plansDataAffiliate) {
            Object.assign(plainDto, {
              records: plansDataAffiliate.result.affiliateSubscriptionDto.map,
            });
            this.setState({
              plansDataAffiliate1: plansDataAffiliate,
              AllPlansForMemberAfi: plainDto,
            });
          }
        }
      }
    }

    if (planUpdate.planPriceId !== undefined) {
      if (planUpdate !== planUpdateData) {
        if (
          planUpdate &&
          planUpdate.paymentStatus === "pending" &&
          !!localStorage.getItem("paymentFailedButLetUserIn") === false
        ) {
          this.context.router.history.push("/add-payment-method");
          // if (window.location.pathname !== '/profile-terms') {
          //   this.context.router.history.push('/add-payment-method');
          // }
        }
        // else {
        //   this.context.router.history.push('/dashboard');
        // }

        const result = {
          catgoryId: "",
          pageNumber: 0,
          pageSize: 5,
          searchKeyword: "",
          sortBy: "",
          userId: localStorage.getItem("userId"),
          searchType: "Available",
          defaultView: "dashboard",
        };

        getAllFilteredDSettlement(result);

        getAllFilteredSettlement({
          pageNumber: 0,
          pageSize: 5,
          searchKeyword: "",
          catgoryId: 0,
          sortBy: "",
          userId: localStorage.getItem("userId"),
          searchType: "All",
        });

        getPromotedSettlementByUserId({
          pageNumber: 0,
          pageSize: 5,
          searchKeyword: "",
          userId: localStorage.getItem("userId"),
        });
        this.props.getAllDashboard({ userId: localStorage.getItem("userId") });

        this.setState({
          planUpdateData: planUpdate,
          planId: planUpdate.planPriceId,
        });
      }
    }
    if (userData !== affiliateUserTypeArray) {
      if (typeof affiliateUserTypeArray !== "undefined") {
        this.setState({
          // affiliateType: affiliateUserTypeArray.affiliateType,
          userData: affiliateUserTypeArray,
        });
      }
    }
    if (userInfo !== undefined) {
      if (userInfo.userId !== undefined) {
        if (userInfo !== userResult) {
          this.props.getBusinessUser(userInfo.userId);
          this.props.getNotificationLogUnReadCountForUser({
            userId: userInfo.userId,
          });
          if (userInfo.userObject.userDto.affiliateKey !== undefined) {
            // this.props.getAffiliateUserType(data)
            this.props.getAffiliateDetailByAffiliateKey(
              userInfo.userObject.userDto.affiliateKey
            );
          }

          this.setState({
            userResult: userInfo,
            affiliateKeyData:
              userInfo.userObject.userDto.affiliateKey !== "undefined" &&
              userInfo.userObject.userDto.affiliateKey !== null
                ? userInfo.userObject.userDto.affiliateKey
                : "",
          });
        }
      }
    }
  }

  onMenuSelect = (sMenu) => {
    this.props.onMenuSelect(sMenu);
  };

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const { data } = nextProps;
  //   const { userResult, custId } = prevState;

  //   if (data.userInfo !== undefined) {
  //     if (data.userInfo !== userResult) {
  //       nextProps.getBusinessUser(custId);
  //       console.log('ssssssssssdddddddddddddddddd', data.userInfo);
  //       return { userResult: data.userInfo };
  //     }
  //   }
  //   return true;
  // }

  logout = async () => {
    await localStorage.clear();
    Auth.signOut()
      .then(async () => {
        await this.props.logoutUser();
        this.props.clearDataEmail();
        this.context.router.history.push("/");
      })
      .catch((error) => error);
  };

  handleClick = (e) => {
    const { isToggle } = this.state;
    e.preventDefault();

    this.setState({ isToggle: !isToggle });
  };

  render() {
    const { userInfo, notificationCount } = this.props.data;
    const { isLoader, makeitAutomatic } = this.state;

    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    if (
      typeof userInfo.user !== "undefined" &&
      window.location.pathname !== "/" &&
      window.location.pathname !== "/change-password" &&
      window.location.pathname !== "/profile-terms" &&
      window.location.pathname !== "/change-plan" &&
      window.location.pathname !== "/user-agreement" &&
      window.location.pathname !== "/revocable-letter-of-agency" &&
      window.location.pathname !== "/add-payment-method" &&
      window.location.pathname.split("/")[1] !== "service-agreement" &&
      window.location.pathname.split("/")[1] !== "signup"
    ) {
      const { roleName } = userInfo;
      const { AllPlansForMemberAfi, affiliateKeyData } = this.state;
      const { pathname } = this.props.location;
      const aplySubTab = pathname.substring(1, 6);
      const className = "active";
      // const { userName, handleClick } = this.props;
      const { AllPlansForMember, BusinessUserProfileData } = this.props.data;
      let menus;
      if (roleName === "Affiliate" || roleName === "Affiliate-SubUser") {
        menus = (
          <div>
            <li className={pathname === "/dashboard" ? className : ""}>
              <Link to="/affiliate">Dashboard</Link>
            </li>
            <li className={pathname === "/profile" ? className : ""}>
              <Link to="/profile">My Profile</Link>
            </li>
            <li
              className={pathname === "/SettlementAffiliate" ? className : ""}
            >
              <Link to="/SettlementAffiliate">Settlements</Link>
            </li>
            <li className={pathname === "/enrollmentpage" ? className : ""}>
              <Link to="/enrollmentpage">Enrollments</Link>
            </li>
            <li className={pathname === "/myReferrals" ? className : ""}>
              <Link to="/myReferrals">My Referrals</Link>
            </li>
            <li className={pathname === "partner-pages" ? className : ""}>
              <Link to="/partner-pages">Resources</Link>
            </li>
            {/* <li><a target="_blank" href={landingPageUrl}>Partner Landing Pages</a></li> */}
            <li>
              <a onClick={this.logout}>Logout</a>
            </li>
          </div>
        );
      } else if (roleName === "Consumer") {
        menus = (
          <div>
            <li className={pathname === "/dashboard" ? className : ""}>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li
              className={
                pathname === "/settlement" || aplySubTab === "apply"
                  ? className
                  : ""
              }
            >
              <Link to="/settlement">Settlements</Link>
            </li>
            <li className={pathname === "/enrollment" ? className : ""}>
              <Link to="/enrollment">Enrollments</Link>
            </li>
            <li className={pathname === "/profile" ? className : ""}>
              <Link to="/profile">My Profile</Link>
            </li>
            {/* <li className={pathname === '/activity-log' ? className : ''}><Link to='/activity-log'>Activity log</Link></li> */}
            <li className={pathname === "/notifications" ? className : ""}>
              <Link to="/notifications">
                Notifications{" "}
                {/* {notificationCount.unreadNotificationCount !== undefined ? (
                  notificationCount.unreadNotificationCount > 0 ? (
                    <span className='notication-count'>
                      {' '}
                      {notificationCount.unreadNotificationCount}{' '}
                    </span>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}{' '} */}
              </Link>
            </li>

            <li className={pathname === "/help" ? className : ""}>
              <a
                href="http://support.collectivelyapp.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Help
              </a>
            </li>

            <li>
              <a onClick={this.logout}>Logout</a>
            </li>
          </div>
        );
      } else if (roleName === "Business-User") {
        // let urlLink = '/addSubUsersBusiness';
        // if (GetBusinessSubUserList !== undefined) {
        //   if (GetBusinessSubUserList.length > 0) {
        //     urlLink = '/manageSubUsersBusiness';
        //   }
        // }
        menus = (
          <div>
            <li className={pathname === "/dashboard" ? className : ""}>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li
              className={
                pathname === "/settlement" || aplySubTab === "apply"
                  ? className
                  : ""
              }
            >
              <Link to="/settlement">Settlements</Link>
            </li>
            <li className={pathname === "/enrollment" ? className : ""}>
              <Link to="/enrollment">Enrollments</Link>
            </li>
            {/* <li className={pathname === '/manageSubUsersBusiness' || pathname === '/addSubUsersBusiness' || pathname.includes("/businessSubUser") ? className : ''}><Link to={urlLink}>Manage Sub
                    Users</Link></li> */}

            <li className={pathname === "/profile" ? className : ""}>
              <Link to="/profile">My Profile </Link>
            </li>
            {/* <li className={pathname === '/activity-log' ? className : ''}><Link to='/activity-log'>Activity log</Link></li> */}

            <li className={pathname === "/notifications" ? className : ""}>
              <Link to="/notifications">Notifications</Link>
            </li>
            <li className={pathname === "/faq" ? className : ""}>
              <a
                href="http://support.collectivelyapp.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Help
              </a>
            </li>

            <li>
              <a onClick={this.logout}>Logout</a>
            </li>
            {/* {(getPlanNameData === 'Basic' || getPlanNameData === 'Basic Outsourced') */}
            {/* ? <li className="btn-nav center-align"><a className="waves-effect waves-light btn btn-blue" onClick={this.openModal}>Make It Automatic</a></li> */}
            {/* : ''} */}

            {localStorage.getItem("planName") === "Basic" ? (
              <li className="btn-nav center-align">
                <Link
                  className="waves-effect waves-light btn btn-blue"
                  to="/profile-terms"
                >
                  Make It Automatic
                </Link>
                {/*<a*/}
                {/*  className='waves-effect waves-light btn btn-blue'*/}
                {/*  // onClick={this.openModal}*/}
                {/*  href='/add-payment-method'*/}
                {/*>*/}
                {/*  Make It Automatic*/}
                {/*</a>*/}
              </li>
            ) : (
              ""
            )}

            {/* {(localStorage.getItem('planName') !== 'Basic' && localStorage.getItem('planName') !== 'Basic Outsourced') */}
            {/* ? <li className="btn-nav center-align"><a className="waves-effect waves-light btn btn-blue" onClick={this.openModal2}>Update Plan</a></li> */}
            {/* : ''} */}
          </div>
        );
      } else if (roleName === "Business-SubUser") {
        menus = (
          <div>
            <li className={pathname === "/dashboard" ? className : ""}>
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li
              className={
                pathname === "/settlement" || aplySubTab === "apply"
                  ? className
                  : ""
              }
            >
              <Link to="/settlement">Settlements</Link>
            </li>
            <li className={pathname === "/enrollment" ? className : ""}>
              <Link to="/enrollment">Enrollments</Link>
            </li>

            <li className={pathname === "/profile" ? className : ""}>
              <Link to="/profile">My Profile</Link>
            </li>

            <li className={pathname === "/notifications" ? className : ""}>
              <Link to="/notifications">Notifications</Link>
            </li>
            <li className={pathname === "/faq" ? className : ""}>
              <a
                href="http://support.collectivelyapp.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Help
              </a>
            </li>

            <li>
              <a onClick={this.logout}>Logout</a>
            </li>
          </div>
        );
      }
      return (
        <span>
          {/* {this.props.data.tutorialPopupStateAction2.tutorialPopupState2 == true
            ? document.addEventListener("mousedown", this.handleClickOutside)
            : ""} */}

          {loader1}
          {/* <ToastContainer /> */}

          <Modal
            shouldCloseOnOverlayClick={false}
            isOpen={this.state.isPopoOPen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModalPricePoup}
            style={customStyles}
            className="changeplan-popup changeplan-popup-confirmation"
            contentLabel="Example Modal"
          >
            <div className="close-change-plan-popup">
              <a onClick={this.closeModalPricePoup}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
                </svg>
              </a>
            </div>

            <h4 className="col s12 plan-hdr-outer center-align">Update Plan</h4>

            <div className="col s12">
              You've reached your limit of 10 filings included in your original
              basic subscription. To ensure Collectively keeps helping you
              collect, please click <a onClick={this.openModal}> here </a> to
              upgrade to a Premium or Flex account.
            </div>
          </Modal>

          <Modal
            shouldCloseOnOverlayClick={false}
            isOpen={this.state.modalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            style={customStyles}
            className="changeplan-popup"
            contentLabel="Example Modal"
          >
            <div className="close-change-plan-popup">
              <a href="" onClick={this.closeModal1}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
                </svg>
              </a>
            </div>

            <h4 className="col s12 plan-hdr-outer center-align">Update Plan</h4>

            <div className="col s12">
              <PlanPage
                plainDetail={
                  affiliateKeyData !== ""
                    ? AllPlansForMemberAfi
                    : AllPlansForMember
                }
                onPlanSelect={this.onPlanSelectBar}
                enterpriseType={
                  BusinessUserProfileData.enterpriseType !== undefined
                    ? BusinessUserProfileData.enterpriseType
                    : "S"
                }
                totalTaxId={
                  BusinessUserProfileData.totalTaxId !== undefined
                    ? BusinessUserProfileData.totalTaxId
                    : ""
                }
                makeitAutomatic={makeitAutomatic}
              />
            </div>
          </Modal>
          <Modal
            shouldCloseOnOverlayClick={false}
            isOpen={this.state.modal2IsOpen}
            onAfterOpen={this.afterOpenModal2}
            onRequestClose={this.closeModal2}
            style={customStyles}
            className="changeplan-popup"
            contentLabel="Example Modal"
          >
            <div className="close-change-plan-popup">
              <a href="" onClick={this.closeModal2}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
                </svg>
              </a>
            </div>

            {/* <h4 className="col s12 plan-hdr-outer center-align" ref={subtitle => this.subtitle = subtitle}>Settlement Monitoring</h4> */}

            <div className="col s12">
              <PlanPage
                plainDetail={
                  affiliateKeyData !== ""
                    ? AllPlansForMemberAfi
                    : AllPlansForMember
                }
                onPlanSelect={this.onPlanSelectBar2}
                enterpriseType={
                  BusinessUserProfileData.enterpriseType !== undefined
                    ? BusinessUserProfileData.enterpriseType
                    : "S"
                }
                totalTaxId={
                  BusinessUserProfileData.totalTaxId !== undefined
                    ? BusinessUserProfileData.totalTaxId
                    : ""
                }
                makeitAutomatic={makeitAutomatic}
              />
            </div>
          </Modal>
          <ul
            className={
              this.state.isToggle
                ? "sidenav sidenav-fixed show menu-show"
                : "sidenav sidenav-fixed menu-hide"
            }
            id="slide-out"
          >
            <li>
              <div className="user-view">
                <Link to="/dashboard">
                  <img src={ProfilePic} alt="" />
                </Link>
              </div>
            </li>
            <li>
              <div className="divider" />
            </li>
            {menus}
          </ul>
          <div className="container burger-menu-outer">
            <a
              href=""
              data-target="slide-out"
              className="sidenav-trigger"
              onClick={this.handleClick}
            >
              <i className="material-icons">menu</i>
            </a>
          </div>
        </span>
      );
    }

    return null;
  }
}

SideMenu.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAffiliateDetailByAffiliateKey,
      getAllBusinessSubUsers,
      getAllPlans,
      getNotificationLogUnReadCountForUser,
      getBusinessUser,
      planPriceChange,
      logoutUser,
      clearDataEmail,
      requestCreateFusebillCustomer,
      getAllFilteredSettlement,
      getPromotedSettlementByUserId,
      getAllFilteredDSettlement,
      getAllDashboard,
      tutorialPopupStateAction2,
      tutorialPopupStateAction3,
    },
    dispatch
  );

export default withRouter(
  windowSize(connect(mapStateToProps, mapDispatchToProps)(SideMenu))
);
